import styled, {css} from 'styled-components';

import type {Props} from './types';

import {getColor, square, type WithThemeProp} from '../../styles';
import {platform} from '../../utils/platform';

export const getIconSize = (size: Props['size']) => {
  if (typeof size === 'number') {
    return size;
  }

  if (typeof size === 'object') {
    return size;
  }

  switch (size) {
    case 'la':
      return 64;
    case 'me':
      return 40;
    case 'ml':
      return 56;
    case 'sm':
      return 32;
    case 'xl':
      return 72;
    case 'xxl':
      return 80;
    case 'xxxl':
      return 98;
    default:
      return 24;
  }
};

export const Icon = styled(({svg, ...rest}) => {
  const SVG = svg;

  if (platform.isWeb) {
    const testID = rest.testID;

    delete rest.testID;

    rest['data-test-id'] = testID;
  }

  return <SVG {...rest} />;
}).attrs((p: Props & WithThemeProp) => ({
  fill: getColor(p.color || 'icon.black')(p),
}))<Props>`
  ${p => {
    const size = getIconSize(p.size);

    if (typeof size === 'number') {
      return square(size);
    }

    if (typeof size === 'object') {
      switch (true) {
        case 'width' in size && 'height' in size:
          return css`
            width: ${size.width}px;
            height: ${size.height}px;
          `;
        case 'width' in size:
          return css`
            width: ${size.width}px;
          `;
        case 'height' in size:
          return css`
            height: ${size.height}px;
          `;
      }
    }
  }};
`;
